module.exports = __webpack_public_path__ + "static/media/mobileScreenshot10.9a732e6c.jpg";